// PrimeVue's DatePicker takes its day and month names from the PrimeVue locale config, not from
// props, so the app language has to be pushed into that config and kept in step with it.
import { watch } from 'vue';
import i18n from '@/i18n/index';

function monthNamesShort(locale) {
  const formatter = new Intl.DateTimeFormat(locale, { month: 'short' });
  return Array.from({ length: 12 }, (_unused, month) => formatter.format(new Date(2021, month, 1)));
}

// tm() can hand back compiled message functions instead of plain strings; rt() resolves both.
function translatedList(key) {
  const { rt, tm } = i18n.global;
  return tm(key).map((entry) => rt(entry));
}

export function datePickerLocale() {
  const { t } = i18n.global;
  const locale = i18n.global.locale.value;

  return {
    clear: t('select.actions.reset'),
    dayNamesMin: translatedList('constants.days'),
    firstDayOfWeek: 1,
    monthNames: translatedList('constants.months'),
    monthNamesShort: monthNamesShort(locale),
    today: t('select.actions.setToday'),
  };
}

export function syncDatePickerLocale(app) {
  const { config } = app.config.globalProperties.$primevue;

  watch(
    () => i18n.global.locale.value,
    () => {
      Object.assign(config.locale, datePickerLocale());
    },
  );
}
